import { useMemo } from 'react'
import { useLayerContext } from '@layerfi/components'

import { isExperimentalModeEnabled } from '../../utils/isExperimentalModeEnabled'

const baseNavLinks = [
  { to: 'overview', label: 'Overview' },
  { to: 'bank-transactions', label: 'Bank Transactions' },
  { to: 'reports', label: 'Reports' },
  { to: 'ledger', label: 'General Ledger' },
]

export const useNavigationLinks = ({
  forceEnableTimeTracking = false,
}: {
  forceEnableTimeTracking?: boolean
}) => {
  const { accountingConfiguration } = useLayerContext()
  const enableTimeTracking =
    isExperimentalModeEnabled() || forceEnableTimeTracking

  return useMemo(
    () => [
      ...baseNavLinks,
      ...(enableTimeTracking ? [{ to: 'time-tracking', label: 'Time Tracking' }] : []),
      ...(accountingConfiguration?.enableTaxEstimates ? [{ to: 'tax-estimates', label: 'Tax Estimates' }] : []),
      ...(accountingConfiguration?.enableMileageTracking ? [{ to: 'mileage-tracking', label: 'Mileage Tracking' }] : []),
    ],
    [accountingConfiguration?.enableMileageTracking, accountingConfiguration?.enableTaxEstimates, enableTimeTracking],
  )
}
